<template>
  <svg class="svg-icon" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z"
      stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M20 20L16 16" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>

<script>
export default {
  name: "SearchIcon",
}
</script>

<style lang="scss" scoped>
path {
  stroke: var(--font-color);
}
</style>